import React, { useEffect } from "react";
import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";
import { HiX } from "react-icons/hi";

/*  Our LOCAL component imports */

/*  Our GLOBAL component imports */
import { Footnote, Headline } from "../../../../Components/Text";
import { LoadingSkeleton } from "../../../../Components/Skeloton";
import { filterKeys } from "../../../../Utilities/Studio";
import { CardGrid, CardGridStyle } from "./Components/CardGrid";
import { FeaturedBanner } from "../FeaturedBanner";
import { EStudioTabView } from "../../../../@types";
import { ToggleAllButton } from "../ToggleAllButton";
import {
  RemoveSelectedItemBubble,
  SelectedItemBubble,
} from "../../../../StyledComponents";

export const MainRail = ({
  query,
  creatorCards,
  handleCardClick,
  cardCount,
  toggleExclusiveModal,
  handleCardToggle,
  onQuery,
  facetLoading,
  setModal,
  homepageData,
  homepage,
  banner,
  remixedCards,
  muted,
  setMuted,
  view,
  handleToggleAll,
}: any) => {
  useEffect(() => {}, [homepageData, facetLoading, creatorCards]);
  const isMarketPlace = view === EStudioTabView.Marketplace;
  const hideToggleAll = isMarketPlace && !homepage;
  const CardCountIndicator = () => {
    if (facetLoading && isMarketPlace)
      return <LoadingSkeleton height={30} width={66} />;
    if (homepage || !isMarketPlace) return <></>;
    if (cardCount) return <>{cardCount} cards</>;
    return <></>;
  };

  //This toggle all handles when we have a faceted search in place
  // const MainToggleAll = () => {
  //   if (homepage) return <></>;

  //   return (
  //     <ToggleAllButton
  //       handleToggleAll={handleToggleAll}
  //       facetLoading={facetLoading}
  //     />
  //   );
  // };

  const FilterList = () => {
    if (!isMarketPlace) return <></>;

    return (
      <>
        {" "}
        {Object.keys(query)
          .filter((x) => !filterKeys.includes(x))
          .map((category) => {
            if (!category) return <></>;
            if (!Array.isArray(query[category])) return <></>;
            return query[category].map((label: any) => {
              return (
                <>
                  <SelectedItemBubble
                    onClick={() => {
                      onQuery(false, category, label, false, true);
                    }}
                  >
                    <StyledFootnote>
                      <span style={{ color: "#F7FCFD" }}>{label}</span>
                    </StyledFootnote>
                    <RemoveSelectedItemBubble></RemoveSelectedItemBubble>
                  </SelectedItemBubble>
                </>
              );
            });
          })}
      </>
    );
  };

  return (
    <Rail py={[8, 10, 10, 10]} px={[4, 7, 7, 7]}>
      <FeaturedBanner
        category={banner}
        view={view}
        facetLoading={facetLoading}
        handleCardClick={handleCardClick}
      />
      <Flex
        justifyContent="space-between"
        alignItems="center"
        mt={[6, 6, 4, 4]}
      >
        <Flex
          justifyContent="flex-start"
          alignItems="center"
          flexWrap={"wrap"}
          mt={1}
        >
          <Headline minWidth={"70px"} mr={5}>
            <CardCountIndicator />
          </Headline>
          <FilterList />
        </Flex>

        {hideToggleAll && (
          <ToggleAllButton
            handleToggleAll={handleToggleAll}
            category={banner}
          />
        )}
      </Flex>

      <Box py={isMarketPlace ? 5 : 0}>
        {!facetLoading || creatorCards.length ? (
          <CardGrid
            homepage={homepage}
            cards={creatorCards}
            handleCardClick={handleCardClick}
            setExclusiveModalOpen={toggleExclusiveModal}
            handleToggle={handleCardToggle}
            setModal={setModal}
            homepageData={homepageData}
            onQuery={onQuery}
            remixedCards={remixedCards}
            muted={muted}
            setMuted={setMuted}
            view={view}
            handleToggleAll={handleToggleAll}
            category={banner}
          />
        ) : (
          <LoadingCreatorCards />
        )}
      </Box>
    </Rail>
  );
};

const LoadingCreatorCards = () => {
  return (
    <StyledGrid>
      {[1, 1, 1, 1, 1, 1].map((x, i) => {
        return (
          <Box>
            <LoadingSkeleton height={215} style={{ borderRadius: "10px" }} />
            <Flex mt={3} alignItems="flex-start" justifyContent="space-between">
              <Flex mt={2} flexDirection="column">
                <Headline ml={3}>
                  <LoadingSkeleton
                    height={25}
                    width={120}
                    style={{ borderRadius: "6px" }}
                  />
                </Headline>
                <Headline mt={3} ml={3}>
                  <LoadingSkeleton
                    height={22}
                    width={60}
                    style={{ borderRadius: "999px" }}
                  />
                </Headline>
              </Flex>
              <Headline mr={4} mt={1}>
                <LoadingSkeleton
                  height={31}
                  width={56}
                  style={{ borderRadius: "999px" }}
                />
              </Headline>
            </Flex>
          </Box>
        );
      })}
    </StyledGrid>
  );
};

const StyledGrid = styled(CardGridStyle)`
  justify-content: flex-start;
`;

const StyledFootnote = styled(Footnote)`
  font-weight: 600;
  font-size: 12px;
`;

const Rail = styled(Flex)`
  flex-basis: 800px;
  flex-grow: 1;
  flex-direction: column;
  min-height: 1290px;
`;
